import AnimatedOutlet from './AnimatedOutlet';

export default AnimatedOutlet;
